import { DeliveryType, PaymentMethodCode } from '@ahm/api-wrappers-core';

export const WEBINAPP_AHAMOVE_ID = 'ahamove';
export const WEBINAPP_AHAUSER_ID = 'ahauser';
export const WEBINAPP_AHADRIVER_ID = 'ahadriver';
export const WEBINAPP_MOMO_ID = 'momo_deeplink';
export const WEBINAPP_MOMO_MINIAPP = 'momo_permission';
export const WEBINAPP_ZALO_ID = 'zalo';
export const WEBINAPP_ZALOPAY_ID = 'zalopay';
// export const WEBINAPP_SMARTPAY_ID = 'smartpay_deeplink'
export const WEBINAPP_VIETTELPAY_ID = 'viettel-pay_deeplink';
export const WEBINAPP_SHOPEEPAY_ID = 'shopee-pay_deeplink';
export const WEBINAPP_ONWHEEL_ID = 'onwheel';
// export const WEBINAPP_VPBANK_ID = 'vpbank_deeplink'

export type WebinappId =
  | typeof WEBINAPP_AHAMOVE_ID
  | typeof WEBINAPP_AHAUSER_ID
  | typeof WEBINAPP_AHADRIVER_ID
  | typeof WEBINAPP_MOMO_ID
  | typeof WEBINAPP_MOMO_MINIAPP
  | typeof WEBINAPP_ZALO_ID
  | typeof WEBINAPP_ZALOPAY_ID
  | typeof WEBINAPP_VIETTELPAY_ID
  | typeof WEBINAPP_SHOPEEPAY_ID
  | typeof WEBINAPP_ONWHEEL_ID;

export type WebInAppConfig = {
  id: WebinappId;
  appId?: string;
  paymentMethods: PaymentMethodCode[] | null; // paymentMethods === null: allow all methods
  deliveryTypes: DeliveryType[] | null; // deliveryTypes === null: allow all services
  maxCod: number | null; // maxCod === null: use default config of service
  getOrderDetailDuration: number | null; // getOrderDetailDuration === null: use default config
};

export const WEBINAPP_IDS: WebinappId[] = [
  WEBINAPP_AHAMOVE_ID,
  WEBINAPP_AHAUSER_ID,
  WEBINAPP_AHADRIVER_ID,
];

export const MINI_APP_LIST: WebinappId[] = [
  WEBINAPP_MOMO_ID,
  WEBINAPP_MOMO_MINIAPP,
  WEBINAPP_ZALO_ID,
  WEBINAPP_ZALOPAY_ID,
  WEBINAPP_VIETTELPAY_ID,
  WEBINAPP_SHOPEEPAY_ID,
];

export const WEBINAPP_CONFIGS: Record<WebinappId, WebInAppConfig> = {
  [WEBINAPP_AHAUSER_ID]: {
    id: WEBINAPP_AHAUSER_ID,
    appId: WEBINAPP_AHAUSER_ID,
    paymentMethods: null,
    deliveryTypes: null,
    maxCod: null,
    getOrderDetailDuration: null,
  },
  [WEBINAPP_AHADRIVER_ID]: {
    id: WEBINAPP_AHADRIVER_ID,
    appId: WEBINAPP_AHADRIVER_ID,
    paymentMethods: null,
    deliveryTypes: null,
    maxCod: null,
    getOrderDetailDuration: null,
  },
  [WEBINAPP_AHAMOVE_ID]: {
    id: WEBINAPP_AHAMOVE_ID,
    appId: WEBINAPP_AHAMOVE_ID,
    paymentMethods: null,
    deliveryTypes: null,
    maxCod: null,
    getOrderDetailDuration: null,
  },
  [WEBINAPP_MOMO_ID]: {
    id: WEBINAPP_MOMO_ID,
    paymentMethods: [PaymentMethodCode.Momo], // paymentMethods === null: allow all methods
    deliveryTypes: [DeliveryType.Instant, DeliveryType.SameDay], // deliveryTypes === null: allow all services
    maxCod: 500000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
  },
  [WEBINAPP_MOMO_MINIAPP]: {
    id: WEBINAPP_MOMO_MINIAPP,
    paymentMethods: [PaymentMethodCode.Momo], // paymentMethods === null: allow all methods
    deliveryTypes: [DeliveryType.Instant, DeliveryType.SameDay], // deliveryTypes === null: allow all services
    maxCod: 300000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
  },
  [WEBINAPP_ZALO_ID]: {
    id: WEBINAPP_ZALO_ID,
    appId: '1243',
    paymentMethods: [PaymentMethodCode.Zalopay], // paymentMethods === null: allow all methods
    deliveryTypes: [DeliveryType.Instant, DeliveryType.SameDay], // deliveryTypes === null: allow all services
    maxCod: 200000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
  },
  [WEBINAPP_ZALOPAY_ID]: {
    id: WEBINAPP_ZALOPAY_ID,
    appId: '1243',
    paymentMethods: [PaymentMethodCode.Zalopay], // paymentMethods === null: allow all methods
    deliveryTypes: [DeliveryType.Instant, DeliveryType.SameDay], // deliveryTypes === null: allow all services
    maxCod: 200000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
  },
  [WEBINAPP_VIETTELPAY_ID]: {
    id: WEBINAPP_VIETTELPAY_ID,
    appId: 'VIETTEL',
    paymentMethods: [PaymentMethodCode.Viettelpay], // paymentMethods === null: allow all methods
    deliveryTypes: [DeliveryType.Instant, DeliveryType.SameDay], // deliveryTypes === null: allow all services
    maxCod: 500000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
  },
  [WEBINAPP_SHOPEEPAY_ID]: {
    id: WEBINAPP_SHOPEEPAY_ID,
    appId: WEBINAPP_SHOPEEPAY_ID,
    paymentMethods: [PaymentMethodCode.Shopeepay], // paymentMethods === null: allow all methods
    deliveryTypes: [DeliveryType.Instant, DeliveryType.SameDay], // deliveryTypes === null: allow all services
    maxCod: 500000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
  },
  [WEBINAPP_ONWHEEL_ID]: {
    id: WEBINAPP_ONWHEEL_ID,
    paymentMethods: [PaymentMethodCode.Balance], // paymentMethods === null: allow all methods
    deliveryTypes: null,
    maxCod: 500000, // maxCod === null: use default config of service
    getOrderDetailDuration: 5000, // getOrderDetailDuration === null: use default config
  },
};

export function isWebinappId(queryValue: string): queryValue is WebinappId {
  return [...WEBINAPP_IDS, ...MINI_APP_LIST].includes(queryValue as WebinappId);
}

export const WEBINAPP_ONLY_PATHS = ['/game', '/challenges', '/lookback'];
